import { Box } from "@chakra-ui/react";

const DashBoard = () => {
  return <Box m={6}></Box>;
};

export default DashBoard;
